import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initializeApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

import { registerAppCheck } from './app/core/app-check';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const firebaseApp = initializeApp(environment.firebaseConfig);

// App Check añade un div invisible a document.body y luego le pide a
// grecaptcha que renderice el widget dentro. AppComponent usa el selector
// 'body[root]', asi que Angular arranca sobre el propio <body> y al hacerlo
// vacia sus hijos: si inicializamos antes del bootstrap, ese div desaparece y
// grecaptcha.render() falla con "placeholder element must be an element or id".
// De ahi que vaya despues. Llegamos a tiempo porque nada toca Firebase durante
// el arranque: AuthService llama a getAuth() dentro de signInWithGoogle() y
// ChatService crea getDatabase() cuando se inyecta, ya con el chat cargado.
function initAppCheck(): void {
  if (environment.appCheckDebugToken) {
    // Copia de la consola el UUID que imprime el SDK y registralo en
    // Firebase Console -> App Check -> la app -> Manage debug tokens.
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  if (environment.recaptchaEnterpriseSiteKey) {
    // Se guarda la instancia porque AuthInterceptor la necesita para adjuntar
    // la cabecera X-Firebase-AppCheck a las llamadas al backend propio.
    registerAppCheck(
      initializeAppCheck(firebaseApp, {
        provider: new ReCaptchaEnterpriseProvider(
          environment.recaptchaEnterpriseSiteKey,
        ),
        isTokenAutoRefreshEnabled: true,
      }),
    );
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => initAppCheck())
  .catch((err) => console.error(err));
